module.exports = __webpack_public_path__ + "img/kx5600-1.e5384a8e.png";